import { render, staticRenderFns } from "./PropertyChangeRequestActivities.vue?vue&type=template&id=5457c43e"
import script from "./PropertyChangeRequestActivities.vue?vue&type=script&lang=ts"
export * from "./PropertyChangeRequestActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports